const getDefaultState = () => {
  return {
    campaign: {},
    allEvents: null
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_CAMPAIGN: (state, campaign) => {
    state.campaign = { ...campaign };
  },
  SET_ALLEVENT: (state, campaign) => {
    state.allEvents = null;
  },
  RESET: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  //show snackbar
  setCampaign({ commit }, campaign) {
    commit("SET_CAMPAIGN", campaign);
  },
  setAllEvent({ commit }, campaign) {
    commit("SET_ALLEVENT", campaign);
  }
};

const getters = {
  campaign: state => state.campaign,
  allEvents: state => state.allEvents
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
